import "@/App.css";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import { Toaster } from "sonner";
import { LayoutDashboard, Users, ListChecks } from "lucide-react";
import { useState, useEffect } from "react";
import Dashboard from "@/pages/Dashboard";
import Workers from "@/pages/Workers";
import Works from "@/pages/Works";
import WorkerDetail from "@/pages/WorkerDetail";
import Login from "@/pages/Login";

function TopNav() {
  const linkClass = ({ isActive }) =>
    `inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
      isActive
        ? "bg-[#3B5249] text-white"
        : "text-[#3B5249] hover:bg-[#EDECE6]"
    }`;

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-[#E6E6E2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <NavLink to="/" className="flex items-center gap-2.5" data-testid="brand-link">
          <div className="h-9 w-9 rounded-xl bg-[#3B5249] flex items-center justify-center text-white font-semibold font-display">A</div>
          <div className="leading-tight">
            <div className="font-display font-semibold text-[#1A1D1A]">Atölye Takip</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#5C605C]">Ütü · Paket</div>
          </div>
        </NavLink>
        <nav className="flex items-center gap-1 sm:gap-2">
          <NavLink to="/" end className={linkClass} data-testid="nav-dashboard">
            <LayoutDashboard size={16} strokeWidth={1.75} />
            <span className="hidden sm:inline">Panel</span>
          </NavLink>
          <NavLink to="/works" className={linkClass} data-testid="nav-works">
            <ListChecks size={16} strokeWidth={1.75} />
            <span className="hidden sm:inline">İşler</span>
          </NavLink>
          <NavLink to="/workers" className={linkClass} data-testid="nav-workers">
            <Users size={16} strokeWidth={1.75} />
            <span className="hidden sm:inline">Çalışanlar</span>
          </NavLink>
        </nav>
      </div>
    </header>
  );
}

function App() {
  const [token, setToken] = useState(() => localStorage.getItem("auth_token"));

  if (!token) {
    return (
      <>
        <Login onLogin={(t) => {
          localStorage.setItem("auth_token", t);
          setToken(t);
        }} />
        <Toaster position="top-right" richColors />
      </>
    );
  }

  return (
    <div className="min-h-screen grain-bg">
      <BrowserRouter>
        <TopNav />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/works" element={<Works />} />
            <Route path="/workers" element={<Workers />} />
            <Route path="/workers/:id" element={<WorkerDetail />} />
          </Routes>
        </main>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
